import * as $ from "jquery";
import * as ko from "knockout";

// Helpers
import "bootstrap";

// Models
import { PopoverOptionOverrides } from "Content/ts/Models/Bootstrap/TooltipsPopovers/popoverConfiguration";
import { TooltipOptionOverrides, InformationIconTooltipOptions } from "Content/ts/Models/Bootstrap/TooltipsPopovers/tooltipConfiguration";

// Services
import { PopoverServices } from "Content/ts/Shared/KnockoutBindings/Bootstrap/Services/popoverService";
import { TooltipServices } from "Content/ts/Shared/KnockoutBindings/Bootstrap/Services/tooltipService";
import { UniqueIdentifierServices } from "Content/ts/Shared/KnockoutBindings/Services/uniqueIdentifierServices";

export namespace TooltipPopoverBindings {
    const defaultPopoverTrigger = "click hover focus";

    ko.bindingHandlers.tooltip = {
        init: (ele: Element, valueAccessor: () => string | KnockoutObservable<string>, allBindingsAccessor: () => TooltipOptionOverrides) => {
            const element = $(ele),
                value = ko.unwrap(valueAccessor()),
                allbindings = allBindingsAccessor();

            TooltipServices.ConfigureStandardTooltip(ele, allbindings, value, false);

            ko.utils.domNodeDisposal.addDisposeCallback(ele, () => {
                element.tooltip("dispose");
            });
        }
    };

    ko.bindingHandlers.tooltipWithInformationIcon = {
        init: (ele: Element, valueAccessor: () => string | KnockoutObservable<string>, allBindingsAccessor: () => InformationIconTooltipOptions) => {
            const element = $(ele),
                  allbindings = allBindingsAccessor();

            const value = ko.unwrap(valueAccessor()),
                displayCondition = ko.unwrap(allbindings.displayCondition);

            if (allbindings.displayCondition != null && allbindings.displayCondition != undefined) {
                $(ele)
                    .attr("aria-live", "polite")
                    .attr("aria-hidden", `${!displayCondition}`)
                    .hide();
            }

            if (!allbindings.uniqueIdentifier) {
                const observableIdentifier = () => { };

                allbindings.uniqueIdentifier = UniqueIdentifierServices.AddNewIdentifier(observableIdentifier);
                UniqueIdentifierServices.RemoveLinkHash(observableIdentifier);
            }

            element.html(TooltipServices.InformationIconMarkup(value));

            TooltipServices.ConfigureStandardTooltip(ele, allbindings, value, true);

            ko.utils.domNodeDisposal.addDisposeCallback(ele, () => {
                element.tooltip("dispose");
            });
        },
        update: (ele: Element, valueAccessor: () => string, allBindingsAccessor: () => InformationIconTooltipOptions) => {
            const allbindings = allBindingsAccessor();
            const displayCondition = ko.unwrap(allbindings.displayCondition);

            if (displayCondition) {
                $(ele)
                    .attr("aria-hidden", "false")
                    .show();
            }
        }
    };

    ko.bindingHandlers.popover = {
        init: (element: HTMLElement, valueAccessor: () => string | KnockoutObservable<string>, allBindingsAccessor: () => PopoverOptionOverrides) => {
            const ele = $(element),
                  value = ko.unwrap(valueAccessor()),
                  allbindings = allBindingsAccessor();

            ele.popover({
                html: false,
                content: value,
                trigger: defaultPopoverTrigger,
                placement: allbindings.Placement ? allbindings.Placement : "left"
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                $(element).popover("dispose");
            });
        }
    };

    ko.bindingHandlers.popoverWithTemplate = {
        init: (element: HTMLElement, valueAccessor: () => string | KnockoutObservable<string>, allBindingsAccessor: () => PopoverOptionOverrides) => {
            const ele = $(element);
            const allbindings = allBindingsAccessor();

            ($(element)).popover({
                html: true,
                trigger: defaultPopoverTrigger,
                template: PopoverServices.BasePopoverTemplate(allbindings),
                content: PopoverServices.RenderPopoverTemplate(allbindings),
                placement: allbindings.Placement ? allbindings.Placement : "left"
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                ele.popover("dispose");
            });
        }
    };

    ko.bindingHandlers.popoverWithTemplateInfomationIcon = {
        init: (element: HTMLElement, valueAccessor: () => string | KnockoutObservable<string>, allBindingsAccessor: () => PopoverOptionOverrides) => {
            const ele = $(element),
                allbindings = allBindingsAccessor();
            const screenReaderMessage = ko.unwrap(valueAccessor());

            ele.attr("aria-live", "polite")
               .html(PopoverServices.InformationIconMarkup(screenReaderMessage));
                
            ele.popover({
                html: true,
                trigger: defaultPopoverTrigger,
                template: PopoverServices.BasePopoverTemplate(allbindings),
                content: PopoverServices.RenderPopoverTemplate(allbindings),
                placement: allbindings.Placement ? allbindings.Placement : "left"
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                ele.popover("dispose");
            });
        }
    };
}

/**
* Accessibility: Close tooltips and popovers on ESC key (WCAG 1.4.13)
*/
type JQueryHTMLElementWithListenEscKey = JQuery<HTMLElement> & { listenEscKeyToCloseOverlays: () => void };
type JQueryDocumentWithListenEscKey = JQuery<Document> & { listenEscKeyToCloseOverlays: () => void };
($.fn as JQueryHTMLElementWithListenEscKey).listenEscKeyToCloseOverlays = function () {
    return this.each(function () {
        if (("undefined" !== typeof $.fn.tooltip) || ("undefined" !== typeof $.fn.popover)) {
            document.addEventListener('keydown', function (e) {
                if ('Escape' === e.key) {
                    const $openTooltips = $('.tooltip');
                    const $openPopovers = $('.popover');

                    if ($openPopovers.length || $openTooltips.length) {
                        e.stopPropagation();
                        $openTooltips.tooltip('hide');
                        $openPopovers.popover('hide');
                    }
                }
            }, true);
        }
    });
};

($(document) as JQueryDocumentWithListenEscKey).listenEscKeyToCloseOverlays();